import { ref, onMounted, onBeforeUnmount } from 'vue';

// функция безопасная в обращении к DOM. Таймер только после onMounted
// immediate - выполнить функцию сразу в момент монтирования
export function useInterval(func, period, immediate) {
	const timer = ref(null);
	const isRunning = ref(true);
	onMounted(() => {
		timer.value = setInterval(() => {
			if (isRunning.value) {
				func();
			}
		}, period);
		if (immediate) {
			func();
		}
	})
	onBeforeUnmount(() => clearInterval(timer.value));
	return {
		isRunning,
	};
}
